import { SHIFT, VISIT } from '../constants'
import {
  getDateTimeInZone,
  TIME_FORMAT,
  YEAR_FIRST_DATE_FORMAT,
} from '../utils.datetime'
import dayjs from 'dayjs'

export const getRevisionFormInitialValues = (values: any) => {
  return {
    ...values,
    slotNotes: values?.description,
    // utc() is called here to normalize antd date/time picker to understand correct behaviour, to avoid current user zone effect
    patternStart: getDateTimeInZone(values?.startTime).utc(),
    type: values?.siteShift === true ? SHIFT : VISIT,
    startTime: dayjs(values?.startTime).utc().format(TIME_FORMAT),
    endTime: dayjs(values?.endTime).utc().format(TIME_FORMAT),
  }
}

export const getRevisionSubmitValues = (
  values: any,
  isTimeTouched?: boolean | undefined,
  isSiteShift?: boolean | undefined
) => {
  const transformedValues = {
    title: values?.title,
    date: values?.patternStart && dayjs(values?.patternStart).format(YEAR_FIRST_DATE_FORMAT),
    ...(isTimeTouched &&
      values?.startTime && {
        startTime: values?.startTime,
      }),
    ...(isTimeTouched &&
      values?.endTime && {
        endTime: values?.endTime,
      }),
    flexiType: values?.flexiType,
    plannedDuration: values?.plannedDuration,
    addressId: isSiteShift ? undefined : values?.addressId,
    fundingTypeId: values?.fundingTypeId,
    description: values?.slotNotes,
    instanceTypeId: values?.instanceTypeId,
  }

  return transformedValues
}

export const getRevisionReqFormInitialValues = (values: any) => {
  return {
    ...values,
    slotNotes: values?.description,
    type: values?.siteShift === true ? 'shift' : 'visit',
    teamMembers: values?.teamMembers?.map((member: any) => ({
      label:
        member.carer?.name?.first && member.carer?.name?.last
          ? `${member.carer.name.first} ${member.carer.name.last}`
          : undefined,
      value: member.teamMemberId || undefined,
    })),
  }
}
